import { createApp, h } from 'vue';
import ToastMessage from './ToastMessage.vue';

/**
 * トーストのオプション
 */
interface ToastOptions {
  message: string;
  type?: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}

/**
 *　トーストを表示する
 * @param options - トーストのオプション
 */
const showToast = (options: ToastOptions) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const app = createApp({
    /**
     * レンダラー
     */
    render() {
      return h(ToastMessage, {
        ...options,
        /**
         * トーストを閉じる
         */
        onClose: () => {
          app.unmount();
          document.body.removeChild(container);
        },
      });
    },
  });

  app.mount(container);
};

export const toast = {
  /**
   * 成功メッセージを表示する
   * @param message　-　メッセージ
   * @param duration -　表示時間
   */
  success(message: string, duration = 3000) {
    showToast({ message, type: 'success', duration });
  },
  /**
   *　エラーメッセージを表示する
   * @param message -　メッセージ
   * @param duration -　表示時間
   */
  error(message: string, duration = 3000) {
    showToast({ message, type: 'error', duration });
  },
  /**
   *　情報メッセージを表示する
   * @param message -　メッセージ
   * @param duration -　表示時間
   */
  info(message: string, duration = 3000) {
    showToast({ message, type: 'info', duration });
  },
  /**
   *　警告メッセージを表示する
   * @param message -　メッセージ
   * @param duration -　表示時間
   */
  warning(message: string, duration = 3000) {
    showToast({ message, type: 'warning', duration });
  },
};
